import styled, { css } from 'styled-components';
import { Input } from 'antd';
import { EyeTwoTone } from '@ant-design/icons';

interface IErrors {
    error?: string;
}

export const StyledInput = styled(Input.Password)<IErrors>`
    && {
        ${({ theme, error }) => css`
            font-size: ${theme.fontSizes.default};
            height: 3.5rem;
            border-radius: 8px;

            input {
                color: ${theme.colors.font};
            }

            &:hover,
            &:focus {
                ${!error &&
                css`
                    border-color: ${theme.colors.accentColor};
                `};
            }

            ${error &&
            css`
                border-color: ${theme.colors.fail} !important;
            `}
        `};
    }
`;

export const ActiveEyeTwoTone = styled(EyeTwoTone)`
    && {
        ${({ theme }) => css`
            color: ${theme.colors.fail} !important;
        `}
    }
`;
